export default __webpack_public_path__ + "static/media/1.360f3ed6.png";